import * as yup from 'yup';
import { CpfValidator } from './cpf';

yup.addMethod(yup.string, 'cpf', function (message) {
    return this.test('cpf-valido', message || 'CPF inválido', function (value) {
        if (!value) return true; // campo opcional

        const digits = value.replace(/\D/g, '');

        // CPF incompleto ainda em digitação — não valida dígito verificador
        if (digits.length > 0 && digits.length < 11) return true;

        const resultado = CpfValidator(value);

        if (!resultado.valido) {
            return this.createError({
                message:
                    message ||
                    ({
                        'different sizes': 'CPF deve conter 11 dígitos',
                        'same number': 'CPF inválido, mesmo número digitado',
                        'invalid digit': 'CPF inválido'
                    }[resultado.reason] || 'CPF inválido')
            });
        }

        return true;
    });
});
